import type { BlogPost } from '../types'

export const POR_QUE_SIN_REGISTRO_POR_EMAIL: BlogPost = {
  slug: 'por-que-sin-registro-por-email',
  lang: 'es',
  topicId: 'warum-keine-email-registrierung',
  title: 'Por qué Roofora no pide correo al registrarse',
  metaDescription:
    'En Roofora se registra solo con un nombre de usuario y una contraseña - sin correo ' +
    'electrónico, sin teléfono. Por qué lo construimos así.',
  keywords: [
    'presupuestos fotovoltaicos sin correo electrónico',
    'portal de instaladores sin registro por email',
    'pedir presupuestos PV de forma anónima',
    'presupuestos solares sin acoso telefónico',
    'privacidad solicitud solar',
  ],
  publishedAt: '2026-07-09',
  excerpt:
    'Para una cuenta en Roofora solo necesita un nombre de usuario y una contraseña - sin correo ' +
    'electrónico. No es casualidad, es el centro de nuestra promesa de privacidad.',
  sections: [
    {
      type: 'paragraph',
      text:
        'Quien alguna vez haya pedido un presupuesto para una instalación solar probablemente ' +
        'conozca el patrón: se indica el correo electrónico y el teléfono en un formulario - y en ' +
        'pocos días el teléfono no para de sonar. El correo pasa a manos de partners comerciales, ' +
        'acaba en newsletters que nunca se suscribieron, y en algún momento ya no se sabe qué ' +
        'llamada de las diez recibidas corresponde realmente al presupuesto solicitado. Ese es ' +
        'justo el problema que en Roofora quisimos atacar de raíz - y la raíz es el propio correo ' +
        'electrónico.',
    },
    {
      type: 'heading',
      text: 'Un correo electrónico ya es un canal de contacto',
    },
    {
      type: 'paragraph',
      text:
        'La mayoría de los portales solares y de instaladores exigen correo y teléfono ya al crear ' +
        'la cuenta - mucho antes de que ninguna empresa instaladora haya presentado un presupuesto ' +
        'concreto. Desde ese momento, la dirección está en una base de datos a la que pueden ' +
        'acceder varios partners comerciales. Si se le contacta y con qué frecuencia escapa ' +
        'normalmente al control de quien hizo la solicitud. El problema de fondo no es entonces ' +
        '"demasiadas llamadas", sino que los datos de contacto se ceden antes de haber tomado ' +
        'siquiera una decisión informada sobre en quién confiar.',
    },
    {
      type: 'heading',
      text: 'Cómo funciona realmente el registro en Roofora',
    },
    {
      type: 'paragraph',
      text:
        'Para una cuenta de cliente en Roofora necesita exactamente dos cosas: un nombre de usuario ' +
        'y una contraseña. Eso es todo. Sin correo electrónico, sin teléfono, sin dirección ' +
        'postal. En nuestro formulario de registro simplemente no existe ese campo - así que no ' +
        'puede introducir esos datos ni revelarlos por error. Puede enviar de inmediato una ' +
        'solicitud para su instalación solar, comparar presupuestos de empresas instaladoras y ' +
        'completar toda la intermediación de forma anónima, sin que nadie sepa quién es usted ni ' +
        'cómo contactarle.',
    },
    {
      type: 'heading',
      text: '¿Y qué pasa con "he olvidado mi contraseña"?',
    },
    {
      type: 'paragraph',
      text:
        'La objeción obvia: sin correo electrónico normalmente tampoco hay forma de restablecer una ' +
        'contraseña olvidada. Por eso, al registrarse recibe un código de recuperación de un solo ' +
        'uso que puede anotar - similar a la recovery key de los gestores de contraseñas. Con él ' +
        'puede recuperar su cuenta incluso sin un correo electrónico guardado. Es un compromiso ' +
        'deliberado: usted asume la responsabilidad del código, pero a cambio ningún dato de ' +
        'contacto sale de nuestra base de datos sin que se le pida.',
    },
    {
      type: 'heading',
      text: '¿Cuándo se necesita realmente mi correo electrónico?',
    },
    {
      type: 'paragraph',
      text:
        'Solo cuando usted lo decida activamente - y solo para la única empresa instaladora que ' +
        'elija. Si una empresa, tras ver su solicitud (que sigue siendo anónima) y su presupuesto, ' +
        'quiere contactar con usted, decide individualmente si autoriza a esa empresa. Solo tras ' +
        'esa autorización proporciona su correo o teléfono para ese único contacto. Sin ' +
        'autorización colectiva, sin cesión automática a otras empresas.',
    },
    {
      type: 'heading',
      text: 'El resultado: silencio en su bandeja de entrada, hasta que usted decida lo contrario',
    },
    {
      type: 'list',
      items: [
        'Sin bandeja de entrada llena de spam tras la primera solicitud, porque en ese momento aún no existe ningún correo electrónico',
        'Sin llamadas comerciales, porque nadie conoce su teléfono hasta que lo autoriza para una empresa concreta',
        'Control total: decide empresa por empresa, no de forma general para todas las de la plataforma',
        'Sigue pudiendo comparar presupuestos sin restricciones - el anonimato no le cuesta ninguna función',
      ],
    },
    {
      type: 'paragraph',
      text:
        'Esa es la diferencia entre "la privacidad como punto en la política de privacidad" y "la ' +
        'privacidad como configuración por defecto en el código": si un campo directamente no ' +
        'existe, tampoco se puede usar mal. Si quiere comparar presupuestos de instalaciones ' +
        'solares sin que después le acosen comercialmente, pruebe Roofora - el registro dura menos ' +
        'de un minuto y ni siquiera le pedimos su correo electrónico.',
    },
  ],
  relatedLinks: [
    { label: 'Solicitar presupuesto fotovoltaico', href: '/solicitar-presupuesto-fotovoltaico' },
    { label: 'Encontrar instalador fotovoltaico', href: '/encontrar-instalador-fotovoltaico' },
  ],
}
